jQuery_T4NT(document).ready(function($) {
$('#t4s-menu-drawer').on("opendDrawer",function(){

		
		$(".ilyacurswitcher").on("click",function(e){

			document.querySelector('.xcentric-header-geoip').click();
		});

		setTimeout(() => {
  
  $(".ilyacurswitcher").on("click",function(e){

			document.querySelector('.xcentric-header-geoip').click();
		});
}, "400");
	});
     /**
     *  Variant selection changed
     *  data-variant-toggle="{{variant.id}}"
     */
	   $( document ).on( "variant:changed", function( evt ) {
	     // console.log( evt.currentVariant );
	     // $('[data-variant-toggle]').hide(0);
	     // $('[data-variant-toggle="'+evt.currentVariant.id+'"]').show(0);
	   });

});


